module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filesystem":{"show":"Show","download":"Download","move":"Move","delete":"Delete","createFolder":"Create folder"}}}')
  delete Component.options._Ctor
}
